import * as React from 'react';
import { useSelector } from 'react-redux';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { selectFlightEnabled } from '../../../selectors/meta';
import { PhoneConfirmationContainer } from '../../PhoneConfirmationV2Container';

const image = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-desk-4.png';
const imageMobile = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-mob-4.jpg';

/* istanbul ignore next */
export const RequestFormPhoneVerificationContainer = () => {
  const isFlightEnabled = useSelector(selectFlightEnabled);
  const legend = isFlightEnabled ? 'Шаг 4 из 4' : undefined;

  return (
    <FormCardLayout
      dataTestId="RequestFormV2PhoneVerification"
      question="Введите код из смс"
      image={image}
      imageMobile={imageMobile}
      legend={legend}
    >
      <PhoneConfirmationContainer />
    </FormCardLayout>
  );
};
